import React from 'react';

const QuickNavBar = ({ currentPage, setCurrentPage }) => {
  const quickLinks = [
    { id: 'lms', label: 'Courses', icon: '🎓' },
    { id: 'library', label: 'Library', icon: '📚' },
    { id: 'habit-tracker', label: 'Habits', icon: '✅' },
    { id: 'goal-tracker', label: 'Goals', icon: '🎯' }
  ];

  return (
    <>
      <style>{`
        .quick-nav-scroll::-webkit-scrollbar {
          display: none;
        }
      `}</style>
      <div style={{
        background: 'var(--surface-glass)',
        borderBottom: '1px solid var(--border)',
        padding: '0.5rem 0',
        backdropFilter: 'blur(10px)'
      }}>
        <div 
          className="quick-nav-scroll"
          style={{ 
            maxWidth: '1200px', 
            margin: '0 auto', 
            padding: '0 0.75rem',
            display: 'flex',
            gap: '0.5rem',
            alignItems: 'center',
            overflowX: 'auto',
            WebkitOverflowScrolling: 'touch',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
          }}>
          {quickLinks.map((link) => (
          <button
            key={link.id}
            onClick={() => setCurrentPage(link.id)}
            style={{
              background: currentPage === link.id ? 'var(--primary-fire)' : 'transparent',
              color: currentPage === link.id ? 'white' : 'var(--text-dark)',
              border: currentPage === link.id ? 'none' : '1px solid var(--border)',
              padding: '0.4rem 0.75rem',
              borderRadius: '20px',
              fontSize: '0.8rem',
              fontWeight: '500',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '0.3rem',
              transition: 'all 0.3s ease',
              whiteSpace: 'nowrap',
              flexShrink: 0
            }}
            onMouseEnter={(e) => {
              if (currentPage !== link.id) {
                e.target.style.background = 'var(--soft-ash)';
                e.target.style.borderColor = 'var(--primary-fire)';
              }
            }}
            onMouseLeave={(e) => {
              if (currentPage !== link.id) {
                e.target.style.background = 'transparent';
                e.target.style.borderColor = 'var(--border)';
              }
            }}
          >
            <span>{link.icon}</span>
            <span>{link.label}</span>
          </button>
        ))}
        </div>
      </div>
    </>
  );
};

export default QuickNavBar;